import { FC, useContext } from 'react';

import { BonusIcon, Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';

import { getFormattedDate } from '../DynamicBonus/utils';
import { formatMoney } from '../utils';
import s from './CustomTooltip.module.scss';
import { ITooltipProps } from './interfaces';

export const CustomTooltip: FC<ITooltipProps> = ({ data }) => {
  const { t } = useContext(LocalizationContext);

  if (!data) return null;

  const { date, accrued, spent } = data;

  return (
    <div className={s.container}>
      <div className={s.header}>{getFormattedDate('D MMM, dd')(date)}</div>

      <div className={s.block}>
        <span className={s.text}>{t('accrued')}</span>
        <div className={s.total}>
          <BonusIcon />
          {formatMoney(accrued)}
        </div>
      </div>

      <Separator />

      <div className={s.block}>
        <span className={cn(s.text, s.orange)}>{t('waste')}</span>
        <div className={s.total}>
          <BonusIcon />
          {formatMoney(spent)}
        </div>
      </div>
    </div>
  );
};
